export const GRADE_COLORS = {
  AAA: '#2A9D8F',
  AA: '#4ECDC4',
  A: '#3498DB',
  BBB: '#F1C40F',
  BB: '#E67E22',
  B: '#D35400',
  CCC: '#E74C3C',
  CC: '#C0392B',
  C: '#922B21',
  D: '#7F8C8D',
};

export const SECTOR_COLORS = {
  Financial: '#3498DB',
  Energy: '#E67E22',
  Corporate: '#2A9D8F',
  SME: '#FF6B6B',
};

export const VALIDATION_COLORS = {
  validated: '#2A9D8F',
  partial: '#F1C40F',
  needs_review: '#FF6B6B',
};

export const COVERAGE_COLORS = {
  country: '#2A9D8F',
  region: '#3498DB',
  continent: '#C0C5CE',
};

export const SESSION_LAYER_COLORS = {
  sprint_qualifying: '#FFD166',
  sprint: '#FF9F1C',
  qualifying: '#8DE3FF',
  race: '#2A9D8F',
};

export const REGION_COLORS = {
  Europe: '#5DADE2',
  'North America': '#F4C95D',
  'South America': '#FF9F1C',
  'Asia-Pacific': '#2ED3B7',
  'Middle East': '#FF6B6B',
};

export const RACE_TYPE_COLORS = {
  Standard: '#3498DB',
  Sprint: '#FF6B6B',
  Saturday: '#F1C40F',
};

export const PILLAR_CONFIG = [
  { key: 'risk_score', name: 'Risk Management', weight: 35, color: '#FF6B6B' },
  { key: 'performance_score', name: 'Performance Metrics', weight: 25, color: '#4ECDC4' },
  { key: 'impact_score', name: 'Impact Measurement', weight: 20, color: '#3498DB' },
  { key: 'stewardship_score', name: 'Stewardship & Governance', weight: 20, color: '#F1C40F' },
];

export const AA_IMPACT_LOGO_URL = 'https://customer-assets.emergentagent.com/job_8a257b94-459d-46be-b02f-b9f17786ac9f/artifacts/omlpphit_Logo%201.2.jpg';
export const F1_LOGO_URL = 'https://media.formula1.com/common/logos/f1_logo_red.svg';

export const CONSTRUCTOR_LOGO_URLS = {
  mercedes: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/mercedes/2026mercedeslogowhite.webp',
  ferrari: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/ferrari/2026ferrarilogowhite.webp',
  mclaren: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/mclaren/2026mclarenlogowhite.webp',
  red_bull: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/redbullracing/2026redbullracinglogowhite.webp',
  haas: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/haasf1team/2026haasf1teamlogowhite.webp',
  racing_bulls: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/racingbulls/2026racingbullslogowhite.webp',
  audi: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/audi/2026audilogowhite.webp',
  alpine: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/alpine/2026alpinelogowhite.webp',
  williams: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/williams/2026williamslogowhite.webp',
  cadillac: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/cadillac/2026cadillaclogowhite.webp',
  aston_martin: 'https://media.formula1.com/image/upload/c_lfill,w_48/q_auto/v1740000000/common/f1/2026/astonmartin/2026astonmartinlogowhite.webp',
};

export const getGradeColor = (grade) => GRADE_COLORS[grade] || '#7F8C8D';
export const getSectorColor = (sector) => SECTOR_COLORS[sector] || '#C0C5CE';
export const getValidationColor = (status) => VALIDATION_COLORS[status] || '#C0C5CE';
export const getCoverageColor = (level) => COVERAGE_COLORS[level] || '#C0C5CE';
export const getSessionLayerColor = (session) => SESSION_LAYER_COLORS[session] || '#4ECDC4';
export const getRegionColor = (region) => REGION_COLORS[region] || '#C0C5CE';

export const formatCoverageLabel = (level) => {
  if (level === 'country') return 'Country coverage';
  if (level === 'region') return 'Regional fallback';
  if (level === 'continent') return 'Continental fallback';
  return 'Coverage';
};

export const formatSessionLabel = (session) => {
  if (session === 'sprint_qualifying') return 'Sprint Qualifying';
  if (session === 'qualifying') return 'Qualifying';
  if (session === 'sprint') return 'Sprint';
  if (session === 'race') return 'Race';
  return session;
};

export const getConstructorLogoUrl = (teamName = '') => {
  const normalized = teamName.toLowerCase();
  if (normalized.includes('mercedes')) return CONSTRUCTOR_LOGO_URLS.mercedes;
  if (normalized.includes('ferrari')) return CONSTRUCTOR_LOGO_URLS.ferrari;
  if (normalized.includes('mclaren')) return CONSTRUCTOR_LOGO_URLS.mclaren;
  if (normalized.includes('red bull')) return CONSTRUCTOR_LOGO_URLS.red_bull;
  if (normalized.includes('haas')) return CONSTRUCTOR_LOGO_URLS.haas;
  if (normalized.includes('racing bulls')) return CONSTRUCTOR_LOGO_URLS.racing_bulls;
  if (normalized.includes('audi')) return CONSTRUCTOR_LOGO_URLS.audi;
  if (normalized.includes('alpine')) return CONSTRUCTOR_LOGO_URLS.alpine;
  if (normalized.includes('williams')) return CONSTRUCTOR_LOGO_URLS.williams;
  if (normalized.includes('cadillac')) return CONSTRUCTOR_LOGO_URLS.cadillac;
  if (normalized.includes('aston martin')) return CONSTRUCTOR_LOGO_URLS.aston_martin;
  return '';
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
